module.exports = __webpack_public_path__ + "static/media/1.question_loop.ed9d7da1.mp4";